import { styled } from '@mui/material';

export const HBFormRootStyle = styled('form')(({ theme }) => ({}));
